const HistoryActionTypes = {
    ADD_SEARCH_HISTORY: 'ADD_SEARCH_HISTORY',
    REMOVE_SEARCH_HISTORY: 'REMOVE_SEARCH_HISTORY'
};

export default HistoryActionTypes;